/* eslint-disable jsx-a11y/control-has-associated-label */
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from 'components/forms/textField/TextField';
import { GovernmentIdFileFieldWrapper } from './GovernmentIdFileField.styles';

const GovernmentIdFileField = ({
  name,
  label,
}: {
  name: string;
  label: string;
}) => {
  const { t } = useTranslation();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const noFileChosen = t(
    'pageAutomations.preArrivalForm.preview.governmentId.noFileChosen',
  );
  const [fileName, setFileName] = useState(noFileChosen);

  return (
    <GovernmentIdFileFieldWrapper
      role="button"
      onClick={() => {
        fileInputRef.current?.click();
      }}
    >
      <TextField
        rightTooltip={t(
          'pageAutomations.preArrivalForm.preview.governmentId.fileTooltip',
        )}
        leftAddon={t(
          'pageAutomations.preArrivalForm.preview.governmentId.chooseFile',
        )}
        value={fileName}
        id={name}
        colSmInput={12}
        name={name}
        labelOnTop
        readOnly
        label={label}
      />
      <input
        type="file"
        ref={fileInputRef}
        accept="image/*, .pdf"
        onChange={(e) => {
          setFileName(e.target.files?.[0]?.name || noFileChosen);
        }}
      />
    </GovernmentIdFileFieldWrapper>
  );
};

export default GovernmentIdFileField;
